import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'erp-detalhes-item',
  imports: [SkeletonModule],
  templateUrl: './erp-detalhes-item.component.html',
  styleUrl: './erp-detalhes-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErpDetalhesItemComponent
{ 
  public header = input.required<string>()
  public skeletonWidth = input<string | undefined>()
  public description = input<string>()

}
